<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="750px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h2>{{ showTitle }}</h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2 py-4">
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="12">Ar norite užsakyti paiešką?</v-col>
              <v-col cols="12">
                <div class="parametrai">
                  <dl>
                    <dt>Paieškos tipas</dt>
                    <dd>{{ paieskaTipas }}</dd>
                    <template v-if="!isKodas">
                      <dt>Paslauga</dt>
                      <dd>
                        <span v-html="paslaugaListTextAll" />
                      </dd>
                    </template>
                    <template v-if="isJuridinis">
                      <dt>Asmens kodas</dt>
                      <dd>{{ mainData.asm_asmens_kodas }}</dd>
                      <!-- <dt>Pavadinimas</dt>
                      <dd>{{ mainData.asm_pavadinimas }}</dd> -->
                      <template v-if="mainData.foreign">
                        <dt>Užsienio valstybė</dt>
                        <dd>{{ mainData.asm_vls_tekstas }}</dd>
                      </template>
                      <dt>LR Juridinių asmenų registre neregistruotas asmuo</dt>
                      <dd>{{ mainData.foreign ? 'Taip' : 'Ne' }}</dd>
                    </template>
                    <template v-if="isFizinis">
                      <template
                        v-if="
                          !mainData.foreign ||
                            mainData.asm_kodo_tipas === 'iltu'
                        "
                      >
                        <dt>Fizinio asmens kodas</dt>
                        <dd>{{ mainData.asm_asmens_kodas }}</dd>
                      </template>
                      <dt>Vardas</dt>
                      <dd>{{ mainData.asm_fiz_vardas }}</dd>
                      <dt>Pavardė</dt>
                      <dd>{{ mainData.asm_fiz_pavarde }}</dd>
                      <template
                        v-if="
                          mainData.foreign && mainData.asm_kodo_tipas === 'data'
                        "
                      >
                        <dt>Gimimo data</dt>
                        <dd>{{ mainData.asm_gimimo_data }}</dd>
                      </template>
                      <dt>LR Gyventojų registre neregistruotas asmuo</dt>
                      <dd>{{ mainData.foreign ? 'Taip' : 'Ne' }}</dd>
                    </template>
                    <template v-if="isTurtas">
                      <dt>Turto rūšis</dt>
                      <dd>{{ turtasRusisTitle }}</dd>
                      <template v-if="search1 !== null">
                        <dt>{{ search1 }}</dt>
                        <dd>{{ mainData[search1Field] }}</dd>
                      </template>
                      <template v-if="search2 !== null && !isIsrasasNtr">
                        <dt>{{ search2 }}</dt>
                        <dd>{{ mainData[search2Field] }}</dd>
                      </template>
                      <template v-if="isIsrasasNtr">
                        <dt>Fizinio asmens duomenys</dt>
                        <dd>{{ ntrFADuomenysItem.labelConfirm }}</dd>
                        <dt>Su istoriniais duomenimis</dt>
                        <dd>{{ mainData.ntr_su_istorija ? 'Taip' : 'Ne' }}</dd>
                        <dt>Anglų kalba</dt>
                        <dd>{{ mainData.ntr_anglu_kalba ? 'Taip' : 'Ne' }}</dd>
                      </template>
                    </template>
                    <template v-if="isKodas">
                      <template v-if="mainData.be_fizinio_kodo">
                        <dt>Išrašas be fizinio asmens kodo</dt>
                        <dd>{{ mainData.be_fizinio_kodo ? 'Taip' : 'Ne' }}</dd>
                      </template>
                      <dt>Identifikavimo kodas (IDK)</dt>
                      <dd>{{ mainData.obj_identifikavimo_kodas }}</dd>
                    </template>
                    <template v-if="!isKodas && showKaina">
                      <dt>Kaina, Eur</dt>
                      <dd>{{ paieskaKainaViso }}</dd>
                    </template>
                  </dl>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button @click.native="cancelData()">
          Atšaukti
        </el-button>
        <el-button primary @click.native.stop="saveData()">
          Tęsti
        </el-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import paieskaTurtasTipai from './paieskaTurtasTipai'
import paieskaNtrIsrasasTipai from './paieskaNtrIsrasasTipai'
import paieskaPaslaugaList from './paieskaPaslaugaList'
import userRole from '../../mixins/userRole'

export default {
  name: 'PaieskaConfirm',
  props: {
    title: String,
    action: String,
    value: Boolean,
    mainData: Object,
    tipas: String,
    kaina: String,
  },
  components: {},
  mixins: [
    paieskaPaslaugaList,
    paieskaTurtasTipai,
    paieskaNtrIsrasasTipai,
    userRole,
  ],
  data() {
    return {
      //
    }
  },
  computed: {
    ...mapGetters(['appSavitarna']),
    paiTipas() {
      return this.tipas
    },
    paieskaKainaViso() {
      return this.kaina
    },
    showTitle() {
      return this.title
    },
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    modalAction() {
      return this.action ? this.action : 'Confirm'
    },
    paieskaTipas() {
      if (this.paiTipas === 'juridinis') {
        return 'Pagal juridinį asmenį'
      }
      if (this.paiTipas === 'fizinis') {
        return 'Pagal fizinį asmenį'
      }
      if (this.paiTipas === 'turtas') {
        return 'Pagal turtą'
      }
      if (this.paiTipas === 'kodas') {
        return 'Pagal identifikavimo kodą'
      }
      return ''
    },
    isJuridinis() {
      return this.paiTipas === 'juridinis'
    },
    isFizinis() {
      return this.paiTipas === 'fizinis'
    },
    isTurtas() {
      return this.paiTipas === 'turtas'
    },
    isIsrasasNtr() {
      return this.mainData.paslauga === 'israsas'
    },
    isKodas() {
      return this.paiTipas === 'kodas'
    },
    isSavitarna() {
      return this.appSavitarna
    },
    showKaina() {
      return !(
        this.roleRG ||
        this.role('KAC_darbuotojas') ||
        this.roleSkaitytojas
      )
    },
  },
  methods: {
    saveData() {
      this.$emit('confirm' + this.modalAction, this.item)
      this.closeModal()
    },
    cancelData() {
      this.$emit('cancelConfirm')
      this.closeModal()
    },
    closeModal() {
      this.showModal = false
    },
    submit() {
      this.saveData()
    },
    cancel() {
      this.cancelData()
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
.parametrai {
  dl {
    display: flex;
    flex-flow: row wrap;
  }
  dt {
    flex-basis: 40%;
    padding: 2px 4px;
    text-align: right;
    font-weight: 400;
  }
  dd {
    flex-basis: 40%;
    flex-grow: 1;
    margin: 0;
    padding: 2px 4px;
    font-weight: 600;
  }
}
</style>
